import { render, staticRenderFns } from "./BuildsFormComponent.vue?vue&type=template&id=61d71a38&scoped=true&"
import script from "./BuildsFormComponent.vue?vue&type=script&lang=js&"
export * from "./BuildsFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./BuildsFormComponent.vue?vue&type=style&index=0&id=61d71a38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d71a38",
  null
  
)

export default component.exports